export default "__VITE_ASSET__CncMIF$o__"